module.exports = "/_next/static/images/vik-cake-9b7f74950e8a0d778d132e1307a51803.jpg";